import React from "react";
import Dean from "../../components/setting/dean";
import DeputyDean from "../../components/setting/deputyDean";
import "../../assets/css/news.css";
import CreateNews from "../../components/setting/news/createNews";
import TebleNews from "../../components/setting/news/tebleNews";
import NewsCarousel from "../../components/member/info/newsCarousel";

const Setting = () => {
  return (
    <>
      <div className="container">
        <h3 className="text-start mt-3">การตั้งค่า</h3>

        {/* //////////////////////////////////////////////// */}

        <div className="row row-cols-1 row-cols-md-2 g-4">
          <div className="col">
            <Dean />
          </div>
          <div className="col">
            <DeputyDean />
          </div>
        </div>

        {/* //////////////////////////////////////////////// */}
        <hr />
        <div className="row mt-4">
          <div className="col">
            <h4 className="text-start mt-3">การตั้งค่าข่าวสารประชาสัมพันธ์</h4>
          </div>
        </div>
        <NewsCarousel />

        <TebleNews />
      </div>
    </>
  );
};

export default Setting;
